module.exports = window["__sharedAtgBundleLoader"];